import SessionProvider from '@sdk/session/SessionContext';
import { ID } from '@sdk/newsfeed/types/apiTypes';

import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';
import { Page } from '@web/newsfeed/ArticleSearch/types/Page';
import { ArticleSearchProvider } from '@web/newsfeed/ArticleSearch/ArticleSearchProvider/ArticleSearchProvider';
import { EditCommentModalProvider } from '@web/newsfeed/ArticleSearch/EditCommentModalProvider/EditCommentModalProvider';
import { ArticleSearchDetails } from '@web/newsfeed/ArticleSearch/ArticleSearchDetails/ArticleSearchDetails';

import { ArticleSearchList } from './ArticleSearchList/ArticleSearchList';
import { ArticleSearchResultsWrapper } from './articleSearchResults.styles';

export type Props = {
  query: string;
  articleId: ID | null;
  page?: Page;
  searchPageId: ID;
};

const ArticleSearchResultsInner = ({ page, query, articleId, searchPageId }: Props) => {
  return (
    <ArticleSearchProvider
      searchQuery={query}
      page={page}
      articleId={articleId}
      searchPageId={searchPageId}>
      <EditCommentModalProvider>
        <ArticleSearchResultsWrapper>
          {!articleId ? <ArticleSearchList /> : <ArticleSearchDetails />}
        </ArticleSearchResultsWrapper>
      </EditCommentModalProvider>
    </ArticleSearchProvider>
  );
};

export const ArticleSearchResults = (props: Props) => {
  return (
    <QueryClientProvider>
      <SessionProvider>
        <ArticleSearchResultsInner {...props} />
      </SessionProvider>
    </QueryClientProvider>
  );
};
